import { useEffect, useState } from "react";
import ResCon from "../Extra/Rescon";
import WebHelper from "../webhelper";

const DetailTable = ((props) => {
    let data = [...props.result];
    let [limit, setLimit] = useState(10);
    let [last, setLast] = useState(false);

    useEffect(() => {
        if (data.length < limit) {
            setLast(true);
        }
        window.scrollBy({
            top: document.documentElement.offsetHeight,
            behavior: "smooth"
        });
    }, [limit]);

    return (
        <>
            <div className="result-wrapper mt-5">
                <table className="detail-table">
                    <thead>

                        <tr>
                            <th>날짜/회차</th>
                            <th>시간</th>
                            <th>시작</th>
                            <th>줄수</th>
                            <th>결과</th>

                        </tr>
                    </thead>
                    <tbody>
                        {data.reverse().map((item, index) => {
                            if (index > limit) return;

                            return (
                                <tr key={index}>
                                    <td><span >{WebHelper.FormatSingleDate(item.created_at)}</span>-<strong>{item.round}</strong></td>
                                    <td>{WebHelper.FormatHoursOnly(item.created_at)}</td>
                                    <td>
                                        <div className="icon-center">
                                            {item.ball_1 % 2 == 0 && <div className="red_size">우</div>}
                                            {item.ball_1 % 2 != 0 && <div className="blue_size">좌</div>}

                                        </div>
                                    </td>
                                    <td>
                                        <div className="icon-center">
                                            {item.ball_1 > 14 && <div className="red_size">4</div>}
                                            {item.ball_1 <= 14 && <div className="blue_size">3 </div>}
                                        </div>
                                    </td>

                                    <td>
                                        <div className="icon-center">
                                            {(item['ball_1'] % 2 != 0 && item['ball_1'] <= 14) && <ResCon type={"r"} text={'짝'} />}
                                            {(item['ball_1'] % 2 == 0 && item['ball_1'] <= 14) && <ResCon type={"b"} text={'홀'} />}
                                            {(item['ball_1'] % 2 != 0 && item['ball_1'] > 14) && <ResCon type={"b"} text={'홀'} />}
                                            {(item['ball_1'] % 2 == 0 && item['ball_1'] > 14) && <ResCon type={"r"} text={'짝'} />}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

            </div>
            {!last &&
                <div className="result-wrapper mt-5" >
                    <button className="loadmore" onClick={() => {
                        setLimit(limit += 20)
                    }}>더보기</button>
                </div>
            }
        </>
    )
});




export default DetailTable;